
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1346","height":"937","viewBox":"0 0 1346 937","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"553.086","cy":"550.516","rx":"553.086","ry":"386.068","fill":"url(#paint0_radial_110_7743)","fill-opacity":"0.6"}}),_c('ellipse',{attrs:{"cx":"714.273","cy":"440.026","rx":"630.764","ry":"440.026","fill":"url(#paint1_radial_110_7743)","fill-opacity":"0.6"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_110_7743","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"translate(553.086 550.516) rotate(90) scale(386.068 553.086)"}},[_c('stop',{attrs:{"offset":"0.240385","stop-color":"#03C5C5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#43505C","stop-opacity":"0"}})]),_c('radialGradient',{attrs:{"id":"paint1_radial_110_7743","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"translate(714.273 440.026) rotate(90) scale(440.026 630.764)"}},[_c('stop',{attrs:{"offset":"0.240385","stop-color":"#826ECC"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#8C7ACE","stop-opacity":"0"}})])])])
          )
        }
      }
    